import React, { Component } from 'react';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,

} from 'reactstrap';
import {
  studentProgramInclusion,
  agreementAllDetails,
} from 'Actions';

class ProgramInclusions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewdiv: false,
      student:''
    };
  }

  UNSAFE_componentWillMount() {
    this.props.agreementAllDetails();
  }

  handleChange = (selectedOption) => { 
    if (selectedOption) {
      this.props.studentProgramInclusion(selectedOption.value) 
        .then(() => {
          this.setState({ viewdiv: true });
        })
    }
  }


  render() {
    const { contractprogramlist, program, loading  } = this.props;
    
    const options = {
      filterType: 'dropdown',
      rowsPerPage: 50,
      responsive:'standard',
      rowsPerPageOptions: [50, 100, 150],
      selectableRowsHideCheckboxes: true,
    };

    const columns = [
      { name: 'sno', label: 'SNO.' },
      { name: 'student', label: 'STUDENT' },
    ];

    const tableData = contractprogramlist
      ? contractprogramlist.map((data, index) => ({
          sno: index + 1,
          student: data.studentname,
        }))
      : [];

    return (
      <div className="tab-pane fade active show" id="tabs-text-5" role="tabpanel" aria-labelledby="tabs-text-5-tab">
        <div className="row">
        <div className="form-group col-sm-12 col-xl-4" style={{margin:"0 auto", marginBottom:"30px"}}>
          {/* <label className="form-control-label" htmlFor="input-username">Select Program Inclusions</label>
          <select name="prminclusion" id="prminclusion" className="form-control" onChange={this.handleChange} required="">
            <option value=""></option>
            {program.map((p, index) => (
                <option value={p.id}>{p.name}</option>
            ))}
          </select> */}
            <Label for="Select" style={{ fontWeight: "bold" }}>Select Program Inclusions</Label>
            <FormGroup>
            <Label for="Select" style={{ fontWeight: "bold" }}>Select Program Inclusions</Label>
              <Selectsearch
                id="student"
                name="student"
                options={program.map(p => ({ value: p.id, label: p.name }))}
                value={program.find(obj => obj.value === this.state.student)}
                onChange={this.handleChange}
                rules={{ required: 'Please select a student' }}
                required
              />
            </FormGroup>
        </div>
        </div>
        <div className="row">
        {this.state.viewdiv && contractprogramlist && (
          <div className="col-sm-12 col-lg-5" style={{margin:"0 auto"}}>
            <MUIDataTable
              data={tableData}
              columns={columns}
              options={options}
            />
          </div>
        )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    const { contractDashboard, contractstudent } = state;
    return {
        contractprogramlist: contractDashboard.contractprogramlist,
        program:contractstudent.allagreementprogram,
        loading:contractstudent.loading
    };
  };

export default connect(mapStateToProps, {studentProgramInclusion,agreementAllDetails})(ProgramInclusions);
